import { render, staticRenderFns } from "./EmptyContent.vue?vue&type=template&id=56d8d81a&scoped=true&"
import script from "./EmptyContent.vue?vue&type=script&lang=js&"
export * from "./EmptyContent.vue?vue&type=script&lang=js&"
import style0 from "./EmptyContent.vue?vue&type=style&index=0&id=56d8d81a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d8d81a",
  null
  
)

export default component.exports